import React from 'react';
import { Outlet } from 'react-router-dom';

import Sidebar from '@/components/layout/Sidebar.tsx';

const DashboardLayout: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-[#f4f7fe]">
      <Sidebar />

      <div className="fixed bottom-0 left-[10%] z-[5] pointer-events-none hidden xl:block">
        <img
          src="/Golfer.png"
          alt="Golfer"
          className="h-auto w-auto object-contain"
          style={{
            maxHeight: 'min(70vh, 600px)',
            height: 'clamp(400px, 50vh, 600px)',
          }}
        />
      </div>

      <main className="flex-1 ml-0 xl:ml-[16%] 2xl:ml-[14.5%] p-5 pt-20 xl:pt-5 bg-[#f4f7fe] overflow-x-hidden">
        <div className="relative z-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
